module.exports = __webpack_public_path__ + "static/media/al.b5306523.svg";